import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormatter',
  standalone: false,
})
export class PhoneFormatterPipe implements PipeTransform {
  // @param value: string
  // @param mask: string

  transform(value: string, mask: string): string {
    if (!mask) {
      return value;
    }
    value = value?.replace(/\D/g, '');
    for (let i = 0; i < mask?.length; i++) {
      if ((mask[i] === '-' || mask[i] === ' ') && i + 1 <= value?.length) {
        value = value.substr(0, i) + mask[i] + value.substr(i);
      }
    }
    return value;
  }
}
